import { createRouter, createWebHistory } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import AuthLayout from '@/layouts/AuthLayout.vue'
import { registerGuard } from './router-guard'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: DefaultLayout,
      meta: {
        requiresAuth: true,
      },

      children: [
        {
          path: '',
          name: 'home',
          component: () => import('@/views/HomeView.vue'),
          meta: {
            title: 'Partner Portal',
          },
        },
      ],
    },

    {
      path: '/signin/error',
      name: 'signinError',
      component: () => import('@/views/authentication/SigninError.vue'),
      meta: {
        title: 'Signin Error',
        allowAnonymous: true,
      },
    },
    {
      path: '/identity/callback',
      component: AuthLayout,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: 'identityCallback',
          component: () =>
            import('@/views/authentication/IdentityCallback.vue'),
        },
      ],
    },
  ],
})

registerGuard(router)

router.beforeEach((to, from, next) => {
  document.title = [to.meta.title, `${import.meta.env.VITE_APP_TITLE}`]
    .filter((t) => !!t)
    .join(' | ')

  next()
})

export default router
